export default function LandingPage(): JSX.Element {
  return (
    <div className="LandingPage">
      <h1>
        {" "}
        <div className="Tag">Folajimi Akinwale</div>
      </h1>
      <div className="loader">
        <span>F</span>
        <span>u</span>
        <span>l</span>
        <span>l</span>
        <span>-</span>
        <span>S</span>
        <span>t</span>
        <span>a</span>
        <span>c</span>
        <span>k</span>
        <span>&nbsp;</span>
        <span>D</span>
        <span>e</span>
        <span>v</span>
        <span>e</span>
        <span>l</span>
        <span>o</span>
        <span>p</span>
        <span>e</span>
        <span>r</span>
      </div>
    </div>
  );
}
